
import { defineComponent } from 'vue'
import alertBox from '@/components/alert-box.vue'
import { hasAppFeature } from '@/api/base'
import PlanRule from '@/views/index/components/plan-rule.vue'
export default defineComponent({
    name: 'InsuranceAddSubtractAdd',
    components: {
        PlanRule,
        'alert-box': alertBox
    },
    props: ['name', 'type', 'count', 'date', 'money', 'addCount', 'isMonth', 'rule'],
    data () {
        return {
            disabled: false,
            active: false,
            showPlanRule: false
        }
    },
    created () {
        this.disabled = false
    },
    methods: {
        hasAppFeature,
        // 取消
        cancel () {
            this.$emit('cancel')
        },
        submit () {
            if (!this.active && hasAppFeature('addPlanAgreement') && this.type === 'add') {
                this.$message.error('请先阅读并同意《方案条款》')
                return
            }
            this.disabled = true
            this.$emit('submit')
        }
    }
})
